
import axios from 'axios';

const upload = async (signedUrl, file) => {
  // Set the options for the file upload
  const options = {
    headers: {
      'Content-Type': file.type,
    },
  };

  // Upload the file
  return axios.put(signedUrl, file, options);
};

export default {
  upload,
};
